export const EXCEL_IMPORT_EXTENSION = ".xlsx";
export const EXCEL_IMPORT_MAX_BYTES = 5 * 1024 * 1024;

export function validateExcelImportFile(file: File): string | null {
  if (!file.name.toLowerCase().endsWith(EXCEL_IMPORT_EXTENSION)) {
    return "Only .xlsx files can be imported.";
  }
  if (file.size > EXCEL_IMPORT_MAX_BYTES) {
    return `The file is larger than ${EXCEL_IMPORT_MAX_BYTES / (1024 * 1024)} MB.`;
  }
  return null;
}
